import type { Menu } from "types/menu"
import { featureFlagIsActive } from "utils/featureFlags"
import { universalMenuItems } from "./universal"

export const PBMenu: Menu = [
  {
    label: "Overview",
    items: [
      {
        label: "Live Trains",
        icon: "pi pi-fw pi-wifi",
        to: "/",
      },
      {
        label: "Network Mapping",
        icon: "pi pi-fw pi-share-alt",
        to: "/network-mapping",
      },
      // {
      //   label: "Lost Time: Trains",
      //   icon: "pi pi-fw pi-clock",
      //   to: "/lost-time-trains",
      // },
      {
        label: "Lost Time",
        icon: "pi pi-fw pi-clock",
        to: "/lost-time-tracks",
        disabled: !featureFlagIsActive("LTIS"),
      },
    ],
  },
  { separator: true },
  {
    label: "Data Catalog",
    items: [
      {
        label: "Fleet Data Catalog",
        icon: "pi pi-fw pi-book",
        to: "/fleetdata",
      },
    ],
  },
  { separator: true },
  {
    label: "Rail Analytics API",
    items: [
      {
        label: "Documentation",
        icon: "pi pi-fw pi-info-circle",
        to: "/analytics-api-documentation",
      },
      {
        label: "Billing",
        icon: "pi pi-fw pi-money-bill",
        to: "/analytics-api-billing",
      },
    ],
  },
  { separator: true },
  ...universalMenuItems({}),
]
